module.exports = __webpack_public_path__ + "static/img/scv.91ba4fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scv.png
// module id = nRmJ
// module chunks = 0